import PropTypes from 'prop-types';
import React from 'react';

import { GlobalStyle, Popover } from './styles';

function InfoPopover({ children, content, placement, color }) {
  return (
    <>
      <GlobalStyle />
      <Popover
        placement={placement}
        trigger="click"
        content={content}
        color={color}
      >
        {children}
      </Popover>
    </>
  );
}

InfoPopover.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.node || PropTypes.string,
  placement: PropTypes.string,
  color: PropTypes.string,
};

InfoPopover.defaultProps = {
  content: '',
  placement: 'bottom',
  color: 'rgba(0, 0, 0, 0.75)',
};

export default InfoPopover;
